import React, { useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { Helmet } from "react-helmet";
import parse from "html-react-parser";
import { getBlogs } from "../../services/BlogService";
import Preloader from "../../Preloader";
import "./BlogsPage.css";

function getBlogTitle(blog) {
  return blog?.blog_subject || blog?.meta_title || "Blog Title";
}

const FALLBACK_IMAGE = "/kuku-assets/images/founder's photo.png";

function BlogDetailsPage() {
  const { blogId } = useParams();
  const { data: blogResponse, isLoading } = useQuery({
    queryKey: ["blogs"],
    queryFn: getBlogs,
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [blogId]);

  if (isLoading) {
    return <Preloader />;
  }

  const blogs = blogResponse?.data || [];
  const blog = blogs.find((item) => String(item.blog_id) === String(blogId));

  if (!blog) {
    return (
      <section className="blog-detail-page">
        <section className="dist-header-title blog-detail-header">
          <div className="max-w-6xl mx-auto px-4">
            <h1>Blog Not Found</h1>
          </div>
        </section>
        <img
          src="/Image/border-bottom-title.png"
          className="w-full header-title-image"
          alt=""
        />
        <div className="blog-detail-empty">
          <p>This blog is not available right now.</p>
          <Link to="/blogs" className="blogs-sidebar__button">
            Back to Blogs
          </Link>
        </div>
      </section>
    );
  }

  const title = getBlogTitle(blog);
  const image = blog.file || FALLBACK_IMAGE;
  const content = blog.blog_content_html || blog.blog_content || "";

  return (
    <>
      <Helmet>
        <title>{`${title} | Kuku Namkeen`}</title>
        <meta
          name="description"
          content={blog.meta_description || blog.blog_content || title}
        />
        <meta name="keywords" content={blog.meta_keywords || title} />
        <link
          rel="canonical"
          href={`https://kukunamkeen.in/blogs/${blog.blog_id}`}
        />
      </Helmet>

      <section className="blog-detail-page">
        <section className="dist-header-title blog-detail-header">
          <div className="max-w-6xl mx-auto px-4">
            <h1>{title}</h1>
          </div>
        </section>
        <img
          src="/Image/border-bottom-title.png"
          className="w-full header-title-image"
          alt=""
        />

        <section className="blog-detail-content">
          <div className="blog-detail-container">
            <div className="blog-detail-image-wrap">
              <img src={image} className="blog-detail-image" alt={title} />
            </div>

            <div className="blog-detail-description">
              {content ? parse(content) : <p>No blog content available.</p>}
            </div>
          </div>
        </section>
      </section>
    </>
  );
}

export default BlogDetailsPage;
